import { useCallback, useState } from "react";

export interface DialogState<TData extends object = Record<string, unknown>> {
  isOpen: boolean;
  data: TData;
}

type UseDialogStateReturn<TData extends object = Record<string, unknown>> = [
  DialogState<TData>,
  (data: TData) => void,
  () => void
];

export const useDialogState = <TData extends object = Record<string, unknown>>(
  initialState: DialogState<TData> = { isOpen: false, data: {} as TData }
): UseDialogStateReturn<TData> => {
  const [state, setState] = useState<DialogState<TData>>(initialState);

  const open = useCallback((data: TData) => {
    setState({ isOpen: true, data });
  }, []);

  const close = useCallback(() => {
    setState((previousState) => ({ ...previousState, isOpen: false }));
  }, []);

  return [state, open, close];
};
